import classNames from 'classnames'

import Image from '../ui/Image/Image'
import CountryCard from './CountryCard/CountryCard'
import { getImageUrl } from '../../utils'
import styles from './OurPresenceCard.module.scss'
import HtmlContent from '../ui/HtmlContent/HtmlContent'

const splitStatement = (statement) => {
  const [firstPart, ...rest] = statement.split(' ')
  return [firstPart, rest.join(' ')]
}

const OurPresenceCard = ({ ourPresenceData }) => {
  const data = ourPresenceData

  return (
    <div className={styles['presence-container']}>
      {data?.map((data, index) => {
        return (
          <div key={'reverse' + data?.id}>
            <div
              className={classNames(
                styles['reverse-row'],
                index % 2 === 0 ? styles['even-row'] : styles['odd-row']
              )}
            >
              <div className={classNames(styles['position-pay-method'], '   ')}>
                {data.description?.map((data) => {
                  const [firstPart, restOf] = splitStatement(data?.text)
                  return (
                    <div key={'description' + data?.id}>
                      <span className={styles.statement}>
                        {firstPart}
                        <br />
                        {restOf}
                      </span>
                      <div className={styles.pageIcon}>
                        <Image
                          src={getImageUrl(data?.image)}
                          alt={data?.image?.alternativeText}
                          className="h-[2rem] md:h-[3.5rem] mt-3 md:mt-0"
                        />
                      </div>
                    </div>
                  )
                })}
              </div>
              <CountryCard countryData={data?.country_links} index={index} />
            </div>
            {data?.disclaimer_description && (
              <div className={classNames(styles['disclaimer-wrapper'])}>
                <HtmlContent content={data?.disclaimer_description} />
              </div>
            )}
          </div>
        )
      })}
    </div>
  )
}
export default OurPresenceCard
